import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MapPin, ArrowRight, TrendingUp } from "lucide-react";
import { http } from "@/lib/data";

export const RealEstateBand = () => {
  const { data } = useQuery({ queryKey: ["re-cities"], queryFn: () => http.get("/re/cities").then((r) => r.data) });
  const cities = (data?.items || []).slice(0, 8);
  return (
    <section data-testid="home-real-estate" className="bg-gradient-to-b from-amber-50 to-[#F8FAFC] border-b border-amber-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-amber-700 flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />Location-based real estate</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">Where should you buy property next?</h2>
            <p className="text-slate-600 mt-2 max-w-2xl">Compare cities and localities by price per sq.ft, rental yield and growth — then meet RERA-verified projects near you.</p>
          </div>
          <Link to="/real-estate" data-testid="home-re-explore" className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#1E293B] text-white font-bold hover:bg-[#0F172A]"><MapPin className="w-4 h-4" />Explore near me</Link>
        </div>
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
          {cities.map((c, i) => (
            <Link key={c.id} to={`/real-estate?city=${c.id}`} data-testid={`home-re-city-${c.id}`} style={{ animationDelay: `${i * 50}ms` }} className="rise group rounded-2xl bg-white border border-slate-200 p-5 hover:border-amber-300 hover:shadow-lg transition-[box-shadow,border-color]">
              <p className="font-display font-bold text-lg">{c.name}</p>
              <p className="text-xs text-slate-500">{c.state}</p>
              <p className="font-mono font-bold mt-4">₹{c.avg_price_sqft.toLocaleString("en-IN")}<span className="text-xs font-sans text-slate-400"> /sq.ft</span></p>
              <p className="text-xs font-semibold text-[#059669] mt-1 flex items-center gap-1"><TrendingUp className="w-3.5 h-3.5" />+{c.avg_yoy}% in 1 yr</p>
              <ArrowRight className="w-4 h-4 text-amber-600 mt-3 group-hover:translate-x-1 transition-transform" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
